import { Card, Typography } from 'antd';
import { DateField } from '@refinedev/antd';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { SalesIconComponent } from 'assets/icons/sales';
import { ShowLayout } from '../../../components/layout/layout/ShowLayout';
import { useShow } from '@refinedev/core';
import type { IProductBonus } from 'interfaces/product_bonuses';

const { Title, Text } = Typography;

export const BonusShow = () => {
  const { queryResult } = useShow<IProductBonus>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader title="Visualizar Bônus" icon={SalesIconComponent} />
      <Card>
        <Title level={5}>ID</Title>
        <Text>{record?.id}</Text>
        <Title level={5}>Usuário</Title>
        <Text>{record?.user.full_name_or_name}</Text>
        <Title level={5}>Produto</Title>
        <Text>{record?.product.name}</Text>
        <Title level={5}>Motivo</Title>
        <Text>{record?.motive}</Text>
        <Title level={5}>Expiração</Title>
        <DateField value={record?.expires_at}></DateField>
      </Card>
    </ShowLayout>
  );
};
